import { useMemo } from "react";
import type { WrappedFieldMetaProps } from "redux-form";

import { useFormErrors } from "@js/forms/hooks";
import { getErrorsForRequiredFields, pluralize } from "@js/utils";

import type {
  FreelancerBidFormValues,
  PublicFreelancerBidFormValues,
} from "../../utils/bid-form";

export const REQUIRED_FIELDS: Array<keyof FreelancerBidFormValues> = [
  "freelancer_availability",
  "payment_amount",
  "new_application_answers",
  "location_requirement_met",
  "timezone_requirement_met",
  "legally_authorized_to_work",
  "visa_sponsorship_may_be_required",
  "resume",
];

export const REQUIRED_PUBLIC_FORM_FIELDS: Array<
  keyof PublicFreelancerBidFormValues
> = [...REQUIRED_FIELDS, "first_name", "last_name", "email"];

export const useBidErrorSectionErrors = ({
  meta,
  isPublicBidForm,
}: {
  meta: WrappedFieldMetaProps;
  isPublicBidForm?: boolean;
}) => {
  const { errors } = useFormErrors(meta);
  const requiredFields = useMemo(() => {
    return isPublicBidForm ? REQUIRED_PUBLIC_FORM_FIELDS : REQUIRED_FIELDS;
  }, [isPublicBidForm]);
  const requiredErrors = getErrorsForRequiredFields(errors, requiredFields);

  const getMessage = () => {
    const length = Object.keys(requiredErrors).length;
    if (length) {
      return `You are missing ${length} required field${pluralize(length)}`;
    }
  };

  return {
    requiredErrors,
    getMessage,
  };
};
